import { AtlasV2ContentScorePageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2ContentScorePageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasV2ContentPageLayout({ metricType }) {
  const contentPageLayout = {
    contentScore: AtlasV2ContentScorePageLayout
  };
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'keyMetricsPageLayout',
        CustomComponent: contentPageLayout[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
